import { useForm, Controller } from 'react-hook-form';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/forms/button.component';
import useModal from '../../../../hooks/use-close-modal.hook';
import Icon from '../../../../components/forms/icon.component';
import AdvanceRadio from '../../../../components/forms/advance-radio.component';

interface TypeRCSModal {
  show: boolean;
  onRequestClose: (refresh: boolean) => void;
  payload: any;
}

function TypeRCSModal({ show, onRequestClose, payload }: TypeRCSModal) {
  const { t } = useTranslation();
  const modalRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useModal(modalRef, show);
  const options = [
    {
      value: 'basic',
      title: 'Básico',
      description: 'Crea tu plantilla con un mensaje único.',
      required: true
    },
    {
      value: 'single',
      title: 'Simple',
      description: 'Agrega carruseles, tarjetas enriquecidas y combina los elementos necesarios.',
      required: true
    },
    {
      value: 'conversational',
      title: 'Conversacional',
      description: 'Agrega carruseles, tarjetas enriquecidas y combina los elementos necesarios.',
      required: true
    }
  ];
  const defaultValues = {
    type: ''
  };

  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid, isSubmitting }
  } = useForm({
    mode: 'onChange',
    defaultValues
  });

  const selectTypeRCSModal = async (data: any) => {
    await onRequestClose(false);
    reset(defaultValues);

    const routes: Record<string, string> = {
      basic: '/templates-panel/templates-rcs-builder-basic',
      single: '/templates-panel/templates-rcs-builder-single',
      conversational: '/templates-panel/templates-rcs-builder-conversational'
    };

    const route = routes[data.type];
    if (route) {
      navigate(route, { state: { data } });
      resetForm();
    }
  };

  const resetForm = () => {
    onRequestClose(false);
    reset(defaultValues);
  };

  return (
    <div className="modal fade" ref={modalRef} data-bs-backdrop="static">
      <div className="modal-dialog mw-600px">
        <div className="modal-content">
          <div className="modal-header justify-content-end border-0 pb-0">
            <div
              className="btn btn-sm btn-icon btn-active-light-primary"
              onClick={() => resetForm()}
            >
              <Icon icon="ki-cross" size="fs-2x" />
            </div>
          </div>
          <form onSubmit={handleSubmit((data) => selectTypeRCSModal(data))}>
            <div className="modal-body pt-0 pb-15 px-5 px-xl-20">
              <div className="mt-1 text-center">
                <h1>Plantilla RCS</h1>
                <h5 className="text-primary fw-bolder">{payload?.name}</h5>
                <div className="text-muted fw-semibold fs-5">
                  <span
                    dangerouslySetInnerHTML={{ __html: t('channels.rcs.modal-C-Subtitle') }}
                  ></span>
                </div>
                <div className="separator border-2 my-5"></div>
              </div>
              <Controller
                control={control}
                name="type"
                rules={{ required: 'Selecciona el tipo de plantilla RCS' }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <AdvanceRadio
                      {...field}
                      options={options}
                      required
                      errors={error}
                      label={'Tipos de plantillas RCS'}
                    />
                  </>
                )}
              />
              <div className="d-flex flex-center flex-row-fluid pt-0">
                <button
                  type="button"
                  className="btn btn-light hover-scale"
                  onClick={() => resetForm()}
                >
                  {t('general.close')}
                </button>
                <Button
                  type="submit"
                  className="btn btn-primary ms-3 hover-scale"
                  disabled={!isValid}
                  isLoading={isSubmitting}
                >
                  Continuar
                  <Icon icon="ki-double-right" size="fs-1" className="ms-2" />
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default TypeRCSModal;
